module.exports = __webpack_public_path__ + "static/media/equal.278bff74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/equal.svg
// module id = 1411
// module chunks = 0